export const isNotViewer = (rol) => {
    if(rol === 'INFO'){
        return false;
    }
    return true;
}